import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import MasterBulletPoints from "../../../../../V2/Cards/Content/MasterBulletPoints"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokBulletPointIconInfoCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.BulletPointIconInfoCard>) => {
  const infoBlocks = blok.iconInfoBlocks.map((infoBlock) => ({
    iconUrl: infoBlock.icon.filename,
    iconAlt: infoBlock.icon.alt,
    titleText: infoBlock.titleText,
    bodyText: infoBlock.bodyText,
  }))
  return (
    <MasterBulletPoints
      mobileGridOrder={mobileGridOrder}
      itemType="icon_info"
      backgroundColor={blok.backgroundColor}
      superscriptText={blok.superscriptText}
      headerSize={blok.headerSize}
      title={blok.headerText}
      textAlignment={blok.textAlignment}
      descriptionText={blok.descriptionText}
      iconInfoBlocks={infoBlocks}
      priceBadge={blok.priceBadge?.[0]}
      linkText={blok.ctaText}
      linkUrl={storyblokLinkToYocoLink(blok.ctaLink)}
      linkColor={blok.ctaColor}
      linkStyle={blok.ctaStyle}
      videoCoverImage={blok.videoCoverImage?.filename}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokBulletPointIconInfoCard
